<script setup lang="ts">
  import { computed, getCurrentInstance } from 'vue';
  import PosUiSegmented from '@/components/pos-v2/ui/PosUiSegmented.vue';
  import PosUiSettingsCard from '@/components/pos-v2/ui/PosUiSettingsCard.vue';
  import { isStyleMode } from '@/domain/design/design-draft';
  import type { IStyleMode } from '@/interfaces/IStorefrontStyle';

  /** «Modo» (Storefront V2 ADM-3): light, dark or as each diner's phone. */
  const props = defineProps<{ value: IStyleMode }>();
  const emit = defineEmits<{ (e: 'input', mode: IStyleMode): void }>();

  const proxy = getCurrentInstance()!.proxy;
  const t = (key: string) => String(proxy.$t(key));

  const HINT_KEYS: Readonly<Record<IStyleMode, string>> = {
    light: 'design.mode.lightHint',
    dark: 'design.mode.darkHint',
    system: 'design.mode.systemHint',
  };

  const items = computed(() => [
    { id: 'light', label: t('design.mode.light') },
    { id: 'dark', label: t('design.mode.dark') },
    { id: 'system', label: t('design.mode.system') },
  ]);
  const hint = computed(() => t(HINT_KEYS[props.value]));

  function onInput(id: string) {
    if (isStyleMode(id)) emit('input', id);
  }
</script>

<template>
  <PosUiSettingsCard
    class="v2-design-mode-card"
    :title="t('design.mode.title')"
    :description="hint"
  >
    <PosUiSegmented block :value="value" :items="items" @input="onInput" />
  </PosUiSettingsCard>
</template>
